import { render, staticRenderFns } from "./PrintBillingReport.vue?vue&type=template&id=f70882a6"
import script from "./PrintBillingReport.vue?vue&type=script&lang=js"
export * from "./PrintBillingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports